import * as React from "react";
import { TTranslate } from "../../../../service/locale/TranslationService";
import { Form } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { AdditionalEvaluationResultFormConstants } from "../../../../common/Constants";

export interface State {}

export interface Props {
  translate: TTranslate;
  result?: string;
  getFieldDecorator: any;
}

class AdditionalEvaluationResultForm extends React.Component<Props, State> {
  render() {
    const { translate, result, getFieldDecorator } = this.props;
    return (
      <Form>
        <Form.Item
          label={translate("additional_evaluation_result_form.result")}
        >
          {getFieldDecorator(
            AdditionalEvaluationResultFormConstants.FIELDS.RESULT,
            {
              initialValue: result || ""
            }
          )(<TextArea />)}
        </Form.Item>
      </Form>
    );
  }
}

export default AdditionalEvaluationResultForm;
